export default __webpack_public_path__ + "static/media/hazard_map_umi.3a4cd058.jpg";